export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      customerID
      email
      firstname
      lastname
      address {
        nextToken
        items {
            id
            customerID
            address
            district
            email
            firstname
            lastname
            name
            phone
            postcode
            subDistrict
            province
            location {
                lat
                lng
            }
            createdAt
            updatedAt
        }
      }
      phone_number
      basketID
      sales {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;